module.exports = __webpack_public_path__ + "static/01-Hero-Prostate-MRI-Page-f23343a35a99b7798763dede6f727ebf.jpg";